import React from "react";
import data from "../../Data/Data";
import Btn from "../../ReUseAbleComp/Button.jsx";
import Header from "../../ReUseAbleComp/Header.jsx";
import Search from "../../ReUseAbleComp/SearchInput.jsx";
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";
import { Helmet } from "react-helmet";
function LGEnglish({
  searchTagUrdu,
  searchTerm,
  setSearchTerm,
  setUrduSearch,
  UrduSearch,
  handleChange,
}) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <Helmet>
        <title>مقامی حکومت</title>
      </Helmet>
      <Header
        open={open}
        setOpen={setOpen}
        handleOpen={handleOpen}
        handleClose={handleClose}
      />
      <br />
      <br />
      <br />
      <br />
      <center>
        <h1>مقامی حکومت</h1>
        <Search
          handleChange={handleChange}
          searchTerm={searchTerm}
          searchTagUrdu={searchTagUrdu}
          dir="rtl"
        />

        {UrduSearch.map((item) => (
          <Btn
            key={item.id}
            bool={true}
            title={item.Utitle}
            id={item.RID}
            path={`/LGUrduDetails/${item.id}`}
          />
        ))}
      </center>
    </>
  );
}

export default LGEnglish;
